var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-5"},[_c('ConfirmSessionForm',{attrs:{"action":_vm.action,"state":_vm.query.state},on:{"done":_vm.onConfirmDone}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }